<template>
  <header class="header login-header">
    <div class="container px-0">
      <nav class="navbar navbar-expand-lg navbar-light p-0">
        <div class="container-fluid">
          <router-link to="/dashboard" class="navbar-brand">
            <img
              src="/images/logo.svg"
              width="140"
              height="39"
              alt="Logo"
              class="img-fluid header-logo logo-white mr-3" />
          </router-link>

          <div
            class="collapse navbar-collapse header-navbar"
            id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link to="/dashboard-in/IN" class="nav-link"
                  >Dashboard</router-link
                >
              </li>
              <li class="nav-item">
                <router-link to="/search" class="nav-link">Search</router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/handpick-suggestions"
                  style=""
                  class="nav-link"
                  >Handpick Suggestions from Nimbalkar</router-link
                >
              </li>
              <li class="nav-item" v-if="gender == 'F'">
                <router-link to="/all-grooms" class="nav-link"
                  >all Grooms</router-link
                >
              </li>
              <li class="nav-item" v-if="gender == 'M'">
                <router-link to="/all-bride" class="nav-link"
                  >all Brides</router-link
                >
              </li>
            </ul>
          </div>
          <div class="dropdown notification-dd me-3">
            <a
              class="position-relative"
              v-on:click="getNotification(0)"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <img src="/images/notification.svg" width="20" />
              <span class="badge badge-danger count">{{ count }}</span>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuLink">
              <li v-for="(data, index) in notificationList" :key="index">
                <div
                  class="dropdown-item d-flex justify-content-between col-12"
                  v-on:click="redirectTo(data)">
                  <div class="col-2">
                    <img
                      :src="
                        data.from_user && data.from_user.image
                          ? data.from_user.image
                          : 'img/profile.svg'
                      "
                      width="35"
                      height="35"
                      class="rounded-circle object-cover"
                      alt="" />
                  </div>
                  <div class="font-12 time col-10">
                    <div>
                      <p style="margin: 0px !important">
                        {{
                          data.from_user && data.type != "HANDPICK-SUGGESTION"
                            ? $helperService.getText(
                                getName(
                                  data.from_user.first_name,

                                  data.from_user.last_name
                                ),
                                20
                              )
                            : "Nimbalkar"
                        }}
                      </p>
                      <div style="margin: 0px">
                        {{ data.description ? data.description.replaceAll('some suggetions','some profiles') : "" }}
                      </div>
                      <p style="margin: 0px">
                        {{
                          this.$helperService.getFormatedDateAndTime(
                            data.created_at
                          )
                        }}
                      </p>
                    </div>
                    <div>
                      <span
                        v-if="!data.is_read"
                        class="badge badge-success rounded-pill px-2 float-right"
                        style="color: red; justify-content: end; display: flex"
                        >Unread</span
                      >
                      <span
                        v-else
                        class="badge badge-success rounded-pill px-2 float-right"
                        style="
                          color: green;
                          justify-content: end;
                          display: flex;
                        "
                        >Seen</span
                      >
                    </div>
                  </div>
                </div>
              </li>
              <li
                v-if="notificationList.length == 0"
                style="
                  width: 300px;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <img v-if="isloader" src="/img/loader.gif" />
                <span
                  style="color: black !important"
                  v-if="notificationList.length == 0 && !isloader"
                  >No Data Found</span
                >
              </li>
            </ul>
          </div>

          <!-- <div class="lang-dd me-md-3 me-1">
        <select class="form-select" aria-label="Default select example">
        <option selected="" style="background:#333;">EN</option>
        <option value="1" style="background:#333;">MR</option>
      </select>
      </div> -->

          <div class="dropdown profile-dd">
            <a
              class="text-white"
              v-on:click="showMenu()"
              style="cursor: pointer">
              <a id="profile-image-2" v-on:click="getMeCall()"></a>
              <img
                id="profile-image"
                :src="detail.image ? detail.image : '/img/profile.svg'"
                class="me-2 ms-2"
                height="40"
                width="40"
                style="object-fit: contain" />
              <span
                :title="
                  getName(
                    detail.first_name,
                    detail.middle_name,
                    detail.last_name
                  )
                "
                class="d-md-inline d-none">
                {{
                  $helperService.getText(
                    getName(
                      detail.first_name
                      //detail.middle_name,
                      //detail.last_name
                    ),
                    8
                  )
                }}
              </span>
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </a>
            <ul
              id="dropdown-id"
              class="dropdown-menu dropdown-menu-end"
              v-click-outside="clickedOutside">
              <router-link
                to="/my-profile"
                v-on:click="clickedOutside"
                class="dropdown-item"
                ><span class="icon"
                  ><i class="fa fa-user" aria-hidden="true"></i
                ></span>
                My Profile</router-link
              >
              <router-link
                to="/recently-viewed"
                v-on:click="clickedOutside"
                class="dropdown-item"
                ><span class="icon"
                  ><i class="fa fa-history" aria-hidden="true"></i
                ></span>
                My Activity</router-link
              >
              <router-link
                to="/my-settings"
                v-on:click="clickedOutside"
                class="dropdown-item"
                ><span class="icon"
                  ><i class="fa fa-cog" aria-hidden="true"></i
                ></span>
                My Settings</router-link
              >
              <router-link
                to="/my-id"
                v-on:click="clickedOutside"
                class="dropdown-item"
                ><span class="icon"
                  ><i class="fa fa-id-card" aria-hidden="true"></i
                ></span>
                My ID Proof</router-link
              >
              <router-link
                to="/membership-plans"
                v-on:click="clickedOutside"
                class="dropdown-item"
                ><span class="icon"
                  ><i class="fa fa-certificate" aria-hidden="true"></i
                ></span>
                My Membership</router-link
              >
              <a
                class="dropdown-item cursor-pointer"
                v-on:click="showLogoutPopup()"
                ><span class="icon"
                  ><i class="fa fa-share-square" aria-hidden="true"></i
                ></span>
                Logout</a
              >
            </ul>
          </div>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: ">
              <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"></path>
            </svg>
          </button>
        </div>
      </nav>
      <DeleteModal @remove="logout()" ref="logoutModal" />
    </div>
  </header>
</template>
<script>
import $ from "jquery";
import DeleteModal from "@/components/DeleteModal";
export default {
  name: "InnerHeader",
  components: {
    DeleteModal,
  },
  data() {
    return {
      gender: localStorage.getItem("gender"),
      currentTab: location.pathname.replace("/", ""),
      searchObj: {
        offset: 0,
      },
      notificationList: [],
      count: 0,
      length: "",
      loader: "",
      isShow: false,
      eventDisable: false,
      isloader: true,
    };
  },
  watch: {
    "$route.fullPath"(newValue) {
      this.currentTab = newValue.replace("/", "");
    },
  },
  mounted() {
    this.getMeCall();
    // this.getNotification(0);
    this.clickedOutside();
    this.$access_token = localStorage.getItem("access_token");
    if (this.$access_token) {
      this.created();
    }
    $("#menu-toggle,#hear_menu_toggle").click(function (e) {
      e.stopPropagation();
      $("#main-wraper").toggleClass("toggled");
    });
  },
  computed: {
    detail() {
      return this.$store.getters.getUser ? this.$store.getters.getUser : {};
    },
  },
  methods: {
    clickedOutside() {
      if (!this.isShow) {
        var dropdownId = document.getElementById("dropdown-id");
        if (dropdownId) {
          dropdownId.classList.remove("show");
        }
      } else {
        this.isShow = false;
      }
    },
    showMenu() {
      this.isShow = true;
      var dropdownId = document.getElementById("dropdown-id");
      if (dropdownId) {
        if (dropdownId.className.includes("show")) {
          dropdownId.classList.remove("show");
        } else {
          dropdownId.classList.add("show");
        }
      }
    },
    showLogoutPopup() {
      this.isShow = false;
      this.$refs.logoutModal.showModal(
        "Logout",
        "Are you sure you want to logout"
      );
    },
    created() {
      this.interval = setInterval(() => this.getUnreadCount(), 6000);
    },
    mobileMenu() {},
    getName(first, middle, last) {
      var name = "";
      if (first) {
        name = first + " ";
      }
      if (middle) {
        name = name + middle + " ";
      }
      if (last) {
        name = name + last;
      }
      return name;
    },
    logout() {
      if (localStorage.getItem("is_check")) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("gender");
        localStorage.removeItem("is_membership_subscribed");
        localStorage.removeItem("loglevel:webpack-dev-server");
        localStorage.removeItem("tab");
        this.$router.push("/home");
      } else {
        localStorage.clear();
        this.$router.push("/home");
      }
    },
    showDropdown() {
      var dropdownId = document.getElementById("dropdown-id");
      if (dropdownId) {
        if (dropdownId.className.includes("show")) {
          dropdownId.classList.remove("show");
        } else {
          dropdownId.classList.add("show");
        }
      }
      var dropdownMenuId = document.getElementById("dropdown-menu-id");
      if (dropdownMenuId) {
        if (dropdownMenuId.className.includes("show")) {
          dropdownMenuId.classList.remove("show");
        } else {
          dropdownMenuId.classList.add("show");
        }
      }
    },
    getNotification(offset) {
      this.isloader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }
      this.list = [];
      this.searchObj.offset = offset;
      this.searchObj.limit = 4;
      if (offset == 0) {
        this.notificationList = [];
      }
      var access_token = localStorage.getItem("access_token");
      if (access_token) {
        this.$api
          .getAPI({
            _action: "/user/notification/list",
            _body: this.searchObj,
          })
          .then((res) => {
            this.length = res.count;
            this.unreadNotification();

            if (res.list.length > 0) {
              this.notificationList = res.list;
            }
            this.isloader = false;
            // if (this.notificationList.length == 0) {
            //   this.$refs.errorComponent.updateListLoader(false);
            // }
          })
          .catch(() => {});
      }
    },
    getUnreadCount() {
      var access_token = localStorage.getItem("access_token");
      if (access_token) {
        this.$api
          .getAPI({
            _action: "/notification/count",
          })
          .then((res) => {
            this.count = res.count;
          })
          .catch(() => {});
      }
    },
    redirectTo(obj) {
      if (
        obj.from_user.uuid &&
        obj.type != "INTEREST_SENT" &&
        obj.type != "HANDPICK-SUGGESTION"
      ) {
        this.$router.push("/profile-view/" + obj.from_user.uuid);
      } else if (obj.from_user.uuid && obj.type == "INTEREST_SENT") {
        this.$router.push("/intrest-recieved");
      } else if (obj.from_user.uuid && obj.type == "HANDPICK-SUGGESTION") {
        this.$router.push("/handpick-suggestions");
      }
    },
    unreadNotification() {
      this.$api
        .putAPI({
          _action: "/update/notification/status",
          // _body: obj1,
        })
        .then(() => {
          this.count = 0;
        })
        .catch(() => {});
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.detail = res;
          this.$store.commit("setUser", res);
          if (res.is_verified_mobile == "N" && res.is_verified_email == "N") {
            this.$sharedService.clearMap();
            localStorage.clear();
            this.$router.push("/home");
            window.location.reload();
          }
        })
        .catch(() => {});
    },
  },
};
</script>
